const cancel = 'Cancelar'
const save = 'Guardar'

export default {

  global: {
    generalError: ' ¡Ouch! La solicitud no ha sido procesada. Por favor vuelve a cargar la página.',
    signature: 'Vennlig hilsen,',
  },

  component: {
    actionBar: {
      actions: 'Acciones',
      hideActions: 'Ocultar acciones',
    },

    addButton: {
      add: 'Agregar',
    },

    attachments: {
      add: 'Añadir CV u otros documentos solicitados',
      placeholderWithDescription: 'Añadir los anexos solicitados',
      remove: 'Eliminar',
      allowedFileTypes: 'Tipos de archivos permitidos',
      errors: {
        size: 'El archivo es demasiado grande, el tamaño máximo para el archivo es de 5MB',
        empty: 'El archivo no contiene datos',
        invalidType: fileType => `Lo sentimos, no se admiten archivos ${fileType} por motivos de seguridad`,
        typeNotWhitelisted: 'Lo sentimos, no se permite este tipo de archivos.',
      },
    },

    agreeTos: {
      privacyLinkText: 'Política de privacidad',
      termsLinkText: 'Términos y condiciones',
      privacyPolicyText: 'Valoramos su privacidad, por favor lea nuestra ',
      termsText1: 'Lea y acepte los ',
      termsText2: 'antes de facilitarnos sus datos personales.',
      privacyLink: 'https://new.recright.com/privacy-policy',
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyInfo: mail => `Si no quiere que procesemos sus datos personales, puede solicitarnos que los eliminemos enviándonos un mensaje a ${mail}.`,
      customSupportPrivacyInfo: link => `Si no quieres que procesemos tus datos personales, puedes pedir que los eliminen poniéndote en contacto con ${link}.`,
    },

    buttons: {
      close: 'Cerrar',
    },

    competencies: {
      addCompetency: 'Agregar una nueva competencia',
      edit: 'Editar competencias',
      done: 'Hecho',
      defaultsDescription: 'Si no sabes con seguridad qué competencias usar, hemos definido algunas por defecto con las que comenzar.',
      getDefaults: 'Obtener por defecto',
    },

    competency: {
      warning: '¿Eliminar la competencia y todas sus calificaciones?',
    },

    confirmDelete: {
      delete: 'Eliminar',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
    },

    confirm: {
      cancel: 'Eliminar toma',
      confirm: 'Intentar de nuevo',
    },

    confirmButton: {
      wait: count => `Espera ${count}`,
      confirm: 'Confirmar',
    },

    controlStatus: {
      text: {
        empty: 'Llenar',
        valid: () => 'Listo',
      },
      textarea: {
        empty: 'Llenar',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: 'Configurar',
        valid: () => 'Listo',
      },
      file: {
        empty: 'Seleccionar',
        valid: () => 'Cambiar',
      },
      list: {
        empty: 'Agregar',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: 'Buscar',
        valid: () => 'Listo',
      },
    },

    cookieConsentModal: {
      title: 'Nuestro sitio web utiliza cookies',
      body: 'Al aceptar todas las cookies, aceptas el almacenamiento de cookies en tu dispositivo para mejorar la navegación en el sitio, analizar su uso y ayudar en nuestras actividades de marketing.',
      learnMoreLinkText: 'Más información sobre cómo utilizamos las cookies',
      learnMoreLink: 'https://new.recright.com/cookies/', // TODO add localized links when the page is translated
      manageCookies: 'Gestionar las cookies',
      acceptAll: 'Aceptar todas las cookies',
      manageTitle: 'Gestionar las preferencias de consentimiento',
      necessaryCookiesTitle: 'Cookies necesarias',
      necessaryCookiesBody:
        'Estas cookies son necesarias para el funcionamiento del sitio web y no se pueden desactivar en nuestros sistemas.',
      performanceCookiesTitle: 'Cookies de rendimiento',
      performanceCookiesBody:
        'Estas cookies nos permiten contar las visitas y las fuentes de tráfico para poder medir y mejorar el rendimiento de nuestro sitio.',
      confirmChoices: 'Confirmar mis elecciones',
      marketingCookiesTitle: 'Cookies de marketing',
      marketingCookiesBody:
        'Estas cookies nos permiten personalizar la publicidad y medir la efectividad de los anuncios.',
      functionalCookiesTitle: 'Cookies de funcionalidad',
      functionalCookiesBody:
        'Estas cookies se utilizan para mejorar la funcionalidad del sitio web. Sin estas cookies, algunas funciones pueden dejar de estar disponibles. Algunos ejemplos de cookies de funcionalidad son los servicios de chat a través de la web y las preferencias del usuario.',
    },

    emailAddresses: {
      remove: 'Eliminar',
      importCsv: 'Import CSV',
      invalidEmails: 'Se han encontrado correos electrónicos no válidos.',
      maxCsvEntryErrorNotification: amount =>
        `${amount} entradas csv máximas permitidas.`,
      importCsvTooltip:
        'Las filas CSV pueden contener una dirección de correo electrónico o una dirección de correo electrónico y un número de teléfono. Cada fila representa a un destinatario. Los números de teléfono deben tener formato internacional (E.164), por ejemplo, <strong>+358</strong>50xxxxxxx.',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'Correo electrónico rebotado. Asegúrese de que el destinatario ha recibido su mensaje.',
      },
      Permanent: {
        General: 'Error al entregar el correo electrónico. El proveedor de correo electrónico del destinatario ha rechazado el mensaje.',
        NoEmail: 'La dirección de correo electrónico no existe.',
        Suppressed: 'El correo electrónico no se ha entregado debido a intentos fallidos de entrega previos. ',
      },
      Transient: {
        General: 'Correo electrónico rebotado. Asegúrese de que el destinatario ha recibido su mensaje.',
        MailboxFull: 'La bandeja de entrada del destinatario está llena.',
        MessageTooLarge: 'El contenido del mensaje es demasiado grande.',
        ContentRejected: 'Se ha rechazado el contenido del mensaje.',
        AttachmentRejected: 'Se ha rechazado archivo adjunto .',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS message added to message queue, waiting for delivery.',
      failed: 'Sending SMS message failed.',
      duplicate: 'El número proporcionado ya está asignado a un candidato en la entrevista.',
    },

    error403: {
      heading: 'Acceso prohibido',
      content: 'Asegúrate de haber iniciado sesión en la cuenta correcta y de haber sido invitado a revisar este puesto en Recright. Además, asegúrate de utilizar Recright con una única ventana del navegador al mismo tiempo.',
      link: 'Página principal',
    },

    error404: {
      heading: 'Nada aquí',
      content: 'Hemos buscado arduamente, pero no hay ninguna página web en la dirección que has solicitado. Tal vez has seguido un enlace vencido o accidentalmente has ingresado la dirección incorrecta.',
      link: 'Página principal',
    },

    error410: {
      heading: 'Cerrado',
      content: 'El empleo no se puede mostrar porque está cerrado o el período de solicitud ha finalizado.',
      link: 'Página principal',
    },

    calendarError: {
      heading: 'Connecting calendar failed',
      content: 'We were unable to connect your calendar. Please try again later and if the issue continues please contact our support.',
    },

    flash: {
      starting: 'Inicializando...',
      connection_error_hint: 'No se pudo establecer la conexión de red.\nIntenta volver a cargar la página.',
      permission_hint: 'Debes permitir que este sitio use tu webcam y tu micrófono.',
      searching_camera_hint: 'Buscando una webcam...',
      camera_reserved_hint: 'Otra aplicación o página web ha reservado tu cámara web. \nCierra esa aplicación y vuelve a cargar esta página.',
      camera_reserved_hint_chrome_extra: '\n\nEstimado usuario de Chrome, debes permitir que Recright use tu cámara web desde el cuadro de diálogo debajo de la barra de direcciones.',
      no_camera_hint: 'No se ha podido encontrar la cámara web.',
      no_mic_hint: 'No se ha podido encontrar el micrófono.',
      uploading_text: 'Cargando...',
      rtmpt_in_use: 'Este paso no sería necesario si tu red\nnadministrador permitiese RTMP. Pregúntanos cómo.',
      preview_text: 'La cámara web está en modo de vista previa',
      close_text: 'Cerrar cámara',
      remove_text: 'Eliminar toma',
      noflash_errortext_install: link => `It looks like you don't have Adobe Flash Player. You need a flash plugin to record videos. Get flash here: ${link}`,
      noflash_errortext_enable: link => `Si ya has instalado flash, pero aún ves este mensaje. Mira aquí: ${link}`,
      noflash_errortext_differentbrowser: 'Alternativamente puedes probar con un navegador que admita grabación HTML5. Sugerimos Chrome o Firefox.',
    },

    footer: {
      terms: 'Términos y Condiciones de Uso de Recright',
      license: 'Condiciones Generales de Servicio Recright',
      privacyPolicy: 'Política de privacidad',
      customSupport: link => `Ponte en contacto con ${link}`,
      accessibilityReport: 'Accessibility report',
    },

    feedbackPulse: {
      howWouldYouRateInterview: '¿Cómo valorarías tu experiencia en la entrevista?',
      howWouldYouRateJobAd: '¿Cómo calificaría su experiencia de solicitud?',
      yourResponseIsAnonymous: 'Tu respuesta es anónima.',
      thankYouFeedback: '¡Gracias por tu valoración!',
    },

    candidateFooter: {
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyPolicyLink: 'https://new.recright.com/privacy-policy',
      accessibilityReportLink: 'https://new.recright.com/hubfs/RecRight_Accessibility_report.pdf',
    },

    formErrors: {
      typeNotWhitelisted: 'Lo sentimos, no se permite este tipo de archivos.',
      isRequired: 'Este campo es obligatorio.',
      isEmail: value => `${value} no es un correo electrónico válido.`,
      isDate: value => `${value} no es una fecha válida.`,
      invalidUrl: 'La dirección URL es inválida.',
      singleHireEndError: 'La contratación individual no se puede usar más de 60 días.',
      isNotTooOldForLive: 'La fecha ya ha pasado.',
      isNotAfterEndDate: 'La fecha seleccionada no puede ser posterior a la fecha del fin del anuncio de la oferta.',
      isValidMobilePhone: value => `${value ? `${value} is not` : 'Not'} a valid mobile phone number.`,
      isInternationalPhoneNumber: 'Phone number must be in international format.',
      duplicateNumber: 'Ya se ha añadido el número de teléfono.',
      duplicateCompetency: 'Ya existe una competencia con ese nombre',
      isNotDuplicateTemplateName:
        'Ya existe una plantilla de correo electrónico con ese nombre',
    },

    jobAdApplication: {
      name: 'Nombre',
      email: 'Correo electrónico',
      phone: 'Número telefónico',
      city: 'Ciudad',
      applyForPosition: 'Solicitar empleo',
      back: 'Atrás',
      continue: 'Continuar',
      submit: 'Enviar',
      saveForLater: 'Continuar después',
      namePlaceholder: 'Ingresa tu nombre',
      emailPlaceholder: 'Ingresa tu correo electrónico',
      phonePlaceholder: 'Escribe tu número telefónico',
      cityPlaceholder: ' Introduce tu lugar de residencia actual',
      links: 'Agregar enlaces, por ejemplo tu perfil de LinkedIn',
      legendAdditionalFields: 'Información adicional',
      legendBasicInfo: 'Información básica',
      legendLinks: 'Enlaces',
      legendAttachments: 'Adjuntos',
      coverLetter: 'Carta de presentación',
      attachments: 'Adjuntos',
      introduction: 'Escribe tu breve presentación aquí',
      thankYou: 'Gracias.',
      luck: '¡Buena suerte!',
      close: 'Cerrar',
      required: 'Los elementos marcados con * asterisco son obligatorios.',
    },

    jobAdContainer: {
      endTime: date => (date ? `abierto hasta ${date}` : ''),
    },

    jobAdDetails: {
      apply: 'Solicitar empleo',
    },

    jobAdQuickInterview: {
      back: 'Atrás',
      submit: 'Enviar',
      saveForLater: 'Continuar después',
      title: 'Video entrevista rápida',
      description: 'Para conocerte más rápido, nos gustaría que respondas brevemente a nuestra pregunta de entrevista rápida. Saca tu personalidad y dale vida a tu solicitud.',
      requiredNote: 'Toma en cuenta que esta es una parte del proceso de solicitud, y el recruiter recibirá tu solicitud solo después de que hayas registrado tu respuesta.',
      reminderNote: 'Puedes registrar la respuesta de inmediato, o puedes continuar más tarde al recibir un recordatorio en tu correo electrónico.',
    },

    jobAdRow: {
      responses: 'Solicitudes',
      status: {
        open: 'Abierto',
        filled: 'Lleno',
        cancelled: 'Cancelado',
        done: 'Hecho',
        close: 'Cerrar',
        draft: 'Cerrado (borrador)',
        hidden: 'Oculto',
      },
    },

    interviewRow: {
      responses: 'Candidatos',
    },

    linkedInProfile: {
      showLinkedInProfileModal: 'Mostrar perfil de LinkedIn',
    },

    linkedInButton: {
      error: 'Se ha producido un error mientras se buscaba el perfil. Vuelva a intentarlo.',
      buttonText: 'Postularse con linkedIn',
    },

    linkedInContainer: {
      linkedInButtonDescription: 'Puede utilizar su perfil de LinkedIn para rellenar el formulario de solicitud',
      linkedInOr: 'O',
      error: 'Se ha producido un error mientras se buscaba el perfil. Vuelva a intentarlo.',
    },

    linkListInput: {
      addField: 'Agregar',
      removeField: 'Eliminar',
      invalidUrl: 'La dirección URL es inválida.',
    },

    liveRoom: {
      greeting: name => `Hola, ${name}.`,
      notYetStarted: startTime =>
        `La entrevista aún no ha comenzado. La entrevista comienza a las ${startTime}.`,
      interviewTitle: title => `Título de la entrevista: ${title}`,
      interviewStartsIn: timeLeft => `La entrevista comienza en: ${timeLeft}`,
      interviewHasEnded: 'La entrevista ha terminado.',
    },

    loadingButton: {
      loading: 'Cargando...',
      saving: 'Guardar...',
      sending: 'Enviando...',
    },

    modalApplicationForm: {
      applyForPosition: 'Postularse a la vacante',
      continue: 'Continuar',
      name: 'Escribe tu nombre',
      email: 'Ingresa tu dirección de correo electrónico',
      phoneNumber: 'Ingresa tu número telefónico',
      links: 'Puedes ingresar enlaces',
      legendLinks: 'Enlaces',
      legendAttachments: 'Adjuntos',
      coverLetter: 'Carta de presentación',
      attachments: 'Adjuntos',
      introduction: 'Escribe tu presentación aquí',
      thankYou: 'Gracias.',
      luck: '¡Buena suerte!',
      close: 'Cerrar',
    },

    modalConfirm: {
      cancel,
      confirm: 'OK',
    },

    modalAlert: {
      close: 'Close',
    },

    modalLinkShare: {
      title: 'Enlace público compartible',
      info: 'Aquí se muestra una dirección pública de anuncios de trabajo que puede compartir. \nAlguien interesado en el puesto puede ver el anuncio de trabajo \ny luego decidir presentar su solicitud. \nRecibirás la notificación habitual cuando las solicitudes comiencen a llegar.\n\nAquí hay un enlace público del anuncio de trabajo:',
    },

    modalVideoAdd: {
      title: 'Agregar nuevo video',
      chooseTitle: 'Agregar nuevo video',
      titlePlaceholder: 'Escribe el título del video aquí',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: 'Subir un nuevo video',
      info: 'El tamaño de video máximo permitido es de 500mb. Recomendamos que los videos estén comprimidos antes de subirlos, de esta forma la carga y la conversión tomarán menos tiempo.',
    },

    modalCandidateInfo: [
      {
        headline: 'Graba tu video respuesta ',
        content: 'cuantas veces como desees. Los videos se guardarán inmediatamente después de la grabación y podrás volver a la video entrevista a través del enlace que has recibido en tu correo electrónico.',
        mobileContent: 'cuantas veces como desees. Añade el vídeo a la entrevista. Verás cómo se sube el vídeo y se guarda en la entrevista. Puedes volver a ver la entrevista en vídeo a través del enlace que has recibido en tu correo electrónico. <br><br><strong>Si tu pantalla sigue viéndose de color negro y estás utilizando un dispositivo móvil Apple, encontrarás instrucciones para resolver este problema <a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">aquí</a>.</strong>',
      },
      {
        headline: 'Después de grabar, ',
        content: 'asegúrate de que el video se reproduzca correctamente y se escuche tu voz. Cuando presiones el botón «Enviar», tu respuesta quedará bloqueada y ya no podrás editarla.',
      },
      {
        headline: 'Cuando hayas terminado la entrevista, ',
        content: 'Presiona el botón «Enviar respuestas y completar la entrevista». Después de esto, no puedes volver a la video entrevista. Si deseas cerrar esta página pero continuar más adelante con la entrevista, presiona el botón «Continuar más tarde».',
      },
      {
        headline: 'Si necesitas ayuda ',
        content: mailto => `para responder la video entrevista, da clic en el botón «Ayuda» en la parte inferior derecha de la página o envíanos un mensaje al correo electrónico ${mailto}.`,
        customContent: link => `Ponte en contacto con ${link}`,
      },
    ],

    navigationBar: {
      back: 'Atrás',
      dashboard: 'Tablero',
      frontpage: 'Portada',
    },

    personDetails: {
      stage: 'Etapa',
      namePlaceholder: 'Candidato',
      contact: 'Información de contacto',
      referrer: 'Referencia',
      links: 'Enlaces',
      attachments: 'Adjuntos',
      coverLetter: 'Carta de presentación',
      referrerInfo: 'El sitio web desde el cual el candidato llegó al servicio.',
      noStage: 'Aún en ninguna etapa',
      headerAdditionalInformation: 'Información adicional',
      lastSeen: time => `Visto por última vez ${time}.`,
      state: {
        invited: 'Invitado',
        visited: 'Visitado',
        incomplete: 'Incompleto',
        completed: 'Completado',
      },
      notVisited: 'No ha visitado en la entrevista.',
      scheduledInterview: 'Scheduled interview',
      scheduledInterviewInvitationSent: 'Invited to a meeting',
      scheduledInterviewInvitationExpired: 'Invitation has expired',
      scheduledInterviewInvitationEventCreated: 'Meeting:',
      scheduledInterviewReScheduleMeeting: 'Reschedule meeting',
      otherPersons: count => `También se ha encontrado en otros ${count} puestos`,
    },

    phoneInput: {
      placeholder: example => `Teléfono en formato ${example}`,
    },

    questionsAndResponses: {
      response: 'Respuesta',
      noResponse: 'Sin respuesta',
      resetQuestionResponse: 'Borrar la respuesta del candidato',
      resetQuestionResponseConfirm: questionTitle =>
        `¿Está seguro de que desea restablecer la pregunta "${questionTitle}" para el candidato y eliminar su respuesta?`,
      resetQuestionResponseConfirm2:
        'Si lo hace, el candidato puede volver a responder esta pregunta',
    },

    rating: {
      ownVote: 'Tu calificación',
      yourVotePlaceholder: 'No has votado aún.',
      totalVotes: count => `${count} valoraciones en total`,
      mobileModalHeader: 'Añade tu valoración',
      noRatings: 'Aún no hay valoraciones',
      yourRatingReset: 'Restablece tu voto',
      averageRating: 'Puntuación media',
      reset: 'restablecer',
    },

    share: {
      share: 'Compartir con',
      copy: 'Copiar enlace',
    },

    sort: {
      sort: 'Ordenar',
    },

    supportLink: 'support@recright.com',

    typeSelect: {
      selected: 'Seleccionar',
      change: 'Cambiar',
    },

    video: {
      videoNotFound: 'El video está siendo procesado o no se encuentra el video',
      retry: 'Intentar nuevamente',
    },

    videoUpload: {
      uploadPlaceholder: isMobile => (isMobile ? 'Cargar o grabar un nuevo video' : 'Seleccionar archivo'),
      videoPlaceholder: 'Grabar tu respuesta',
      uploadPlaceholderCandidate: 'Sube tu respuesta',
      submit: 'Enviar respuesta',
      notAnswered: 'Aún no se ha respondido',
      remove: 'Eliminar toma',
      converting: 'El video se está convirtiendo. Por favor, espera...',
      uploading: 'Se está subiendo el video. Por favor, espera...',
      error: {
        invalid: 'El archivo seleccionado es demasiado grande. Selecciona otro archivo.',
        upload: 'No hemos podido subir el video, disculpas. Inténtalo de nuevo.',
        transcode: 'El archivo de video seleccionado estaba dañado o no es válido, intenta nuevamente.',
      },
    },

    virtualBg: {
      showMoreButtonText: 'Mostrar más',
      showLessButtonText: 'Mostrar menos',
      infoText1:
        'Mantener la pestaña activa en primer plano durante la grabación. No se debe utilizar ninguna otra aplicación durante la grabación.',
      infoText2:
        'Los fondos de vídeo funcionan mejor en los navegadores más recientes y con un dispositivo relativamente nuevo y potente.',
      infoText3:
        'Asegurarse de que otras aplicaciones no están utilizando el micrófono o la cámara.',
    },

    videoResponse: {
      videoPlaceholder: 'Graba tu respuesta',
      uploadPlaceholder: 'Sube tu respuesta',
      submit: 'Enviar respuesta',
      notAnswered: 'Aún no se ha respondido',
      startInterview: 'Comenzar la entrevista',
    },

    webcam: {
      useVideoBgButtonText: 'Usar fondo de vídeo',
      removeVideoBgButtonText: 'Eliminar fondo de vídeo',
      starting: 'Iniciando...',
      close: 'Cerrar camara',
      remove: 'Eliminar toma',
      record: 'Grabar',
      stop: 'Parar',
      retake: 'Repetir',
      submit: 'Enviar respuesta',
      converting: 'El video se está convirtiendo. Por favor, espera...',
      uploading: 'Se está subiendo el video. Por favor, espera...',
      downloading: 'Se está descargando el video. Por favor, espera...',
      processing: 'Procesando...',
      uploadInProgress: 'La transferencia del video aún está en curso, no cierres el navegador ni cambies la página.',
      uploaded: 'Video transferido.',
      error: {
        DevicesNotFoundError: 'No se puede usar la cámara o el micrófono. Por favor, comprueba que estén habilitados.',
        NotFoundError: 'No se puede usar la cámara o el micrófono. Por favor, comprueba que estén habilitados.',
        NotAllowedError: 'No has dado permiso para usar la cámara o el micrófono.',
        PermissionDismissedError: 'Has descartado el diálogo de permisos. Da permiso para usar la cámara y el micrófono.',
        PermissionDeniedError: 'Has negado el acceso a la cámara o el micrófono.',
        NotReadableError: 'No se puede leer la secuencia de la cámara o el micrófono. Posible problema de hardware.',
        SecurityError: 'No se puede usar la cámara o micrófono debido a un error de seguridad',
        stream: 'Ha ocurrido un error. Por favor, inicia tu navegador nuevamente. Si el problema persiste, intenta con un navegador diferente.',
        download: 'La descarga del video ha fallado. ¿Inténtalo de nuevo?',
        upload: 'La carga del video ha fallado. ¿Inténtalo de nuevo?',
        emptyBlob: 'La memoria de tu navegador o dispositivo está llena y no puede crear la grabación. Actualiza la página y si no funciona, entonces reinicia el navegador. Si el problema persiste, intenta con un navegador diferente.',
        alternativeRecorder: 'También puedes hacer clic en esto para cargar el archivo.',
        reconnecting: 'Se ha interrumpido la conexión. Volviendo a conectar.',
      },
    },

    smsMessages: {
      invitationMessage: title =>
        `¡Hola! ¡Queremos invitarte a una entrevista de vídeo de ${title}! También se ha enviado esta invitación a tu correo electrónico. `,
    },
  },
  page: {
    interviewPreview: {
      info: 'Esta es una vista previa de la entrevista. La grabación de vídeo está desactivada y los datos del formulario no se guardan.',
    },
  },
}
